// extracted by mini-css-extract-plugin
export default {"body":"fQFjzD4V"};